import React from "react"
import "./sidebar.css"

// import profile-img from "../../images/profile-img.jpg"

const Bio = ({ author, tagline }) => {

    return (
        <div className="bio-main pt-3 pl-1">
            {/* <img src={} style={{ maxWidth: `100px` }} className="profile-img" alt="" /> */}
            <h4 className="mb-0">{author}
            <span className="m-0 text-muted ml-2">Linus</span></h4>
            <p className="mb-0">1991.06.17</p>
            <p className="text-muted">{tagline}</p>
        </div>
    )
}

export default Bio